<template>
  <div class="max-w-[1100px] w-full mx-auto">
    <section class="flex items-center ml-4 sm:ml-0 mt-4 sm:mt-9 mb-6 sm:mb-9">
      <OIcon icon="play-game" svg-class="w-5 h-5 sm:w-[30px] sm:h-[30px]" />
      <h1 class="font-semibold text-20 sm:text-24 text-black ml-2.5">{{ $t('game.all-games') }}</h1>
    </section>
    <div class="flex flex-wrap justify-center sm:justify-start gap-4 sm:gap-5">
      <template v-for="(game, index) in games">
        <GameCard :key="game.id" :game="game" />
        <AdController v-if="index === 2" :key="game.id + '_ad'" unit="OyunlarInpage1" class="w-full" />
        <AdController
          v-if="index == 5 || (index > 6 && index % 6 === 5)"
          :key="game.id + '_ad' + index"
          unit="OyunlarInpageMobile2"
          class="w-full"
        />
        <AdController
          :key="game.id + '_ad'"
          class="u-center w-[352px] h-[486px] p-4 bg-white border border-[#E6E6E6] rounded-xl"
          unit="OyunlarInpage4"
          :parent-index="index"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import AdController from '@/modules/ads/components/AdController';
import GameCard from './GameCard.vue';
import { useDevice } from '~/composables/useDevice';
import gameData from '~/modules/oyun/gameData';
import { LANG } from '~/constants/config';
import { OIcon } from '~/modules/common/components/ui';

export default defineComponent({
  setup() {
    const { isMobile } = useDevice();
    const games = gameData.filter((game) => game.description?.[LANG]);
    return { isMobile, games };
  },
  components: {
    GameCard,
    AdController,
    OIcon,
  },
});
</script>

<style></style>
